import React, { Component } from "react";
import {
    Row,
    Col,
    Form,
    Space,
    Button,
    Select,
    Input,
    Table,
    Tooltip,
    message,
    Card,
} from "antd";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";

// import AssignStudentStore from "../store/AssignStudentStore";
import UsersStore from "../store/UsersStore";
import { DeleteFilled } from "@ant-design/icons";
import config from "../config";
import CompanyAutocomplete from "./CompanyAutocomplete";
import StudentStore from "../store/StudentStore";
import VehicleWorkingHoursStore from "../store/VehicleWorkingHoursStore";
import { th } from "date-fns/locale";
import { assign } from "lodash";

class AssignStudent extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        // this.AssignStudentStore = new AssignStudentStore();
        this.UsersStore = new UsersStore();
        this.studentStore = new StudentStore(this);
        this.workingHoursStore = new VehicleWorkingHoursStore();

        this.formRef = React.createRef();
        this.state = {
            loading: false,
            loadList: 0,
            companyId: "",
            text: "",
            buslist: [],
            openAssignForm: false,
            studentlist: [],
            assignedCount: '0',
            unassignedCount: '0',
            selectedRowKeys: [],
            SortStudentBy: '',
            tripType: '',

        };
    }
    async componentDidMount() {
        console.log("props from assign stud", this.props)
        if (Number(this.props.getUserData().isadmin) !== -1) {
            const getVehicles = await this.studentStore.getVehicles(this.props.getUserData().userCompanyId);

            await this.setState({ companyId: this.props.getUserData().userCompanyId, buslist: this.studentStore.assetVehicleList });

        }
        await this.setState({ companyId: this.props.companyId, tripId: this.props.tripId, SortStudentBy: this.props.SortStudentBy, tripType: this.props.tripType });

        this.columns1 = [
            {
                // title: "Assigned Vehicles",
                title: this.context.translate("_STUDENT_"),
                dataIndex: "studentName",
                // key: "passengerId",
                width: 9,
            },
            {
                title: this.context.translate("_CLASS_"),
                dataIndex: "Grade",
                width: 9,
            },
            {
                title: this.context.translate("_STATUS_"),
                dataIndex: "status",
                width: 9,
            }

        ];

        await this.handleSearch();


    }
    closeModal = () => {
        this.props.closeModal();
    };
    async handleChange(comp) {
        console.log("company", comp)
        const getVehicles = await this.studentStore.getVehicles(comp.value);
        console.log(getVehicles);

        await this.setState({ companyId: comp.value });


        await this.setState({ loadList: 1 });

        // await this.handleSearch();
    }

    handleSearch = async (val) => {
        const tripId = this.props.tripId
        const searchName = val
        const data = {
            tripId: tripId,
            searchName: searchName,
            companyId: this.state.companyId,
            SortStudentBy: this.state.SortStudentBy,
            tripType: this.state.tripType

        }
        const getStds = await this.studentStore.getAreawiseStudents(data);
        await this.setState({
            studentlist: this.studentStore.areawiseStudentList,
            selectedRowKeys: this.studentStore.areawiseStudentList.filter(s => s.status === "Assigned")
                .map(s => s.passengerId),
            unassignedCount: getStds.TotalUnassignedCount,
            assignedCount: getStds.TotalassignedCount
        });

    }
    handleBackClick = () => {
        this.props.tabChange("2");
    };
    onStudentAssignStudent = async () => {
        console.log("on submit", this.state.selectedRowKeys)
        const data = {
            passengerId: this.state.selectedRowKeys,
            companyId: this.props.companyId,
            tripId: this.props.tripId,
            tripType: this.state.tripType
        }
        const response = await this.studentStore.assignStudent(data);
        // debugger
        if (response?.data?.success === "S") {
            message.success(response.data.message);
            await this.props.response(response?.data);
            this.closeModal();

        } else {
            message.error(response.data.message);
        }



    };

    render() {

        return (
            <>
                <Row
                    style={{
                        height: "100%",
                    }}
                >
                    <Col span={24} className="formColumnClass">

                        <div style={{
                            padding: '0 5px 0 10px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                        }}>
                            <Input
                                className="uploadCompany"
                                // style={{ width: "50%" }}
                                style={{ flex: 1 }}
                                placeholder={this.context.translate("_SEARCH_STUDENT_")}
                                onChange={this.handleSearch}
                            />
                            <Card style={{ width: '120px' }}>
                                <div className="statTitle">{this.context.translate("_ASSIGNED_")}</div>
                                <div className="statValue">{this.state.assignedCount ? this.state.assignedCount : '0'}</div>
                            </Card>

                            <Card style={{ width: '120px' }}>
                                <div className="statTitle">{this.context.translate("_UNASSIGNED_")}</div>
                                <div className="statValue">{this.state.unassignedCount ? this.state.unassignedCount : '0'}</div>
                            </Card>

                        </div>

                        <div>


                        </div>



                        <Table
                            scroll={{ x: 240, y: 400 }}
                            style={{ padding: '0 5px 0 10px' }}
                            pagination={false}
                            rowKey="passengerId"
                            rowSelection={{
                                columnWidth: 4,
                                selectedRowKeys: this.state.selectedRowKeys,
                                onChange: (selectedRowKeys) => {
                                    this.setState({ selectedRowKeys: selectedRowKeys, selectedRowKeys: selectedRowKeys });
                                },
                            }}
                            columns={this.columns1}
                            dataSource={this.state.studentlist}
                        />




                        <div className="formFooter">
                            <Button
                                className="formsCancelButton"
                                onClick={() => {
                                    this.closeModal();
                                }}
                            >
                                {this.context.translate(
                                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                                )}
                            </Button>

                            <Button
                                onClick={(e) => {
                                    this.handleBackClick();
                                }}
                                className="formsSaveButton"
                            >
                                {this.context.translate("_BACK_")}
                            </Button>


                            <Button
                                style={{ marginInlineStart: "0px" }}
                                loading={this.state.loading}
                                // htmlType="submit"
                                className="formsSaveButton"
                                onClick={this.onStudentAssignStudent}
                            >
                                {this.context.translate("_SUBMIT_")}
                            </Button>

                        </div>


                    </Col>
                </Row>
            </>
        );
    }
}

AssignStudent.contextType = StoreContext;
export default observer(withRouter(AssignStudent));
